import { useEffect } from 'react';
import useQueryMedia from '@/utils/hooks/useQueryMedia';

function useModifyMobileGlobalEle() {
    const [, isPhoneVertical] = useQueryMedia();
    let mo = null;

    useEffect(() => {
        mo = modifyMobileGlobalEle();
        return disconnectMo;
    }, [isPhoneVertical]);

    const modifyMobileGlobalEle = () => {
        const isGlobalEle = (className) => {
            if (typeof className !== 'string' || className.length === 0) return false;
            const globalEleClassNameArr = ['weui-picker__overlay', 'taro__modal'];
            let ret = false;
            for (const name of globalEleClassNameArr) {
                if (className.indexOf(name) !== -1) {
                    console.log('zx modifyMobileGlobalEle node.className:', className, name );
                    ret = true;
                    break;
                }
            }

            return ret;
        };
        
        const modifyEle = (m) => {
            let node = m && m.addedNodes && m.addedNodes.length ? m.addedNodes[0] : null;

            if (!node || !isGlobalEle(node.className) || node.className.indexOf('phone-vertical') !== -1) return;
            try { 
                if (isPhoneVertical) {
                    node.classList.add('phone-vertical');   
                } else {
                    node.classList.remove('phone-vertical');
                }

            } catch (e) {

            }

        };

        const mo = new MutationObserver(muts => {
            for (const m of muts) {
                if (m && m.type === 'childList' && m.addedNodes && m.addedNodes.length) modifyEle(m);
            }
        });

        mo.observe(document.body, { childList: true, subtree: false });

        return mo;
    };

    const disconnectMo = () => { 
        try { if (mo && typeof mo.disconnect === 'function') mo.disconnect(); mo = null; } catch (e) {}
    }
}

export default useModifyMobileGlobalEle;